import { memo } from 'react';
import type { ColorFilterViewModel } from 'autogen/swagger/all';
import FilterMenuSmartView from '../../FilterMenu/FilterMenuSmartView';
import useFilterMenu from '../../FilterMenu/shared/hooks/useFilterMenu';
import ColorFilterOption from './ColorFilterOption';

const ColorFilterMenu = ({
    model: {
        displayName,
        options,
        queryStringName,
        attribute: { id }
    }
}: {
    model: ColorFilterViewModel;
}) => {
    const filterMenuId = id.toString();
    const { closeFilterMenu } = useFilterMenu(filterMenuId);
    return (
        <FilterMenuSmartView name={filterMenuId} headline={displayName} backButtonCallback={closeFilterMenu}>
            {options.map((option) => (
                <ColorFilterOption
                    key={option.displayName}
                    model={option}
                    queryStringName={queryStringName}
                    menuDisplayName={displayName}
                />
            ))}
        </FilterMenuSmartView>
    );
};

export default memo(ColorFilterMenu);
